import { ActionStatus } from '../../../../hooks/useDriversNavigoMachine/types'

export function disabledByPermission(permission: ActionStatus) {
  return permission === 'disabled'
}
